import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { intlMessage } from 'constants/propTypes';
import Message from 'components/Message';
import ReservationCard from './ReservationCard';
import './AttendanceInquiryModal.scss';

const { element } = bem('attendance-inquiry-summary');

const SummarySection = ({ title, description, inquiries }) => {
  if (inquiries.length === 0) return null;

  return (
    <div className={element('section')}>
      <div className={element('section-title')}>
        <Message message={title} />
      </div>
      <div className={element('section-description')}>
        <Message
          message={description}
          values={{
            bold: chunks => <strong>{chunks}</strong>,
          }}
        />
      </div>
      <div className={element('reservation-cards')}>
        {inquiries.map(inquiry => (
          <ReservationCard key={inquiry.inquiryId} inquiry={inquiry} />
        ))}
      </div>
    </div>
  );
};

SummarySection.propTypes = {
  title: intlMessage.isRequired,
  description: intlMessage.isRequired,
  inquiries: PropTypes.arrayOf(
    PropTypes.shape({
      inquiryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      userName: PropTypes.string,
      reservationName: PropTypes.string,
      reservationDatetime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    })
  ).isRequired,
};

export default SummarySection;
